import useTranslation from 'next-translate/useTranslation';
import { IconCrown } from '@tabler/icons-react';

import OnboardingWidget from '../OnboardingWidget';

export function NoContests({
  onCacClick,
  isFullScreen,
  isWide,
}: {
  onCacClick: () => void;
  isFullScreen?: boolean;
  isWide?: boolean;
}) {
  const { t } = useTranslation('commissioner');


  const handleSecondaryButtonClick = () => {
    window.open('https://intercom.help/splashsports-helpcenter/en/collections/12825176-commissioner-help', '_blank');
  };

  return (
    <OnboardingWidget
      subTitle={t('onboardingWidget.noContests.subTitle')}
      title={t('onboardingWidget.noContests.title')}
      description={t('onboardingWidget.noContests.description')}
      Icon={(props) => <IconCrown {...props} />}
      primaryButtonText={t('onboardingWidget.noContests.primaryButtonText')}
      secondaryButtonText={t('onboardingWidget.noContests.secondaryButtonText')}
      onPrimaryButtonClick={onCacClick}
      onSecondaryButtonClick={handleSecondaryButtonClick}
      isFullScreen={isFullScreen}
      isWide={isWide}
    />
  );
}
